export default __webpack_public_path__ + "static/media/pp-video-bg.a91afb2c.mp4";